import { ArrowUpRight } from "lucide-react";

const HERO_IMG = "/hero/hero.jpg";

export default function Hero({ onCta }) {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden bse-grain"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Lacrosse stadium energy"
          className="absolute inset-0 w-full h-full object-cover"
          style={{ filter: "contrast(1.05) saturate(0.9)" }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-[#0a0a0a]" />
        <div className="absolute inset-0 bg-black/30" />

        {/* Americana — faded star field over top half */}
        <div
          aria-hidden
          className="absolute inset-x-0 top-0 h-[70%] bse-stars opacity-[0.07] pointer-events-none"
          style={{ maskImage: "linear-gradient(180deg, #000 30%, transparent 100%)", WebkitMaskImage: "linear-gradient(180deg, #000 30%, transparent 100%)" }}
        />
        {/* Faint diagonal red+navy stripes ribbon on the right edge */}
        <div
          aria-hidden
          className="absolute top-0 right-0 h-full w-[28%] bse-stripes-diag opacity-[0.12] pointer-events-none"
          style={{ maskImage: "linear-gradient(270deg, #000 0%, transparent 100%)", WebkitMaskImage: "linear-gradient(270deg, #000 0%, transparent 100%)" }}
        />
      </div>

      {/* Top label strip */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 pt-28 md:pt-32">
        <div className="flex items-center gap-3 text-[10px] tracking-[0.3em] uppercase text-neutral-300">
          <span className="inline-block w-8 h-px bg-[#e11d2a]" />
          <span>Season 2026 · U-12 Lacrosse</span>
        </div>
      </div>

      {/* Massive type */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 mt-8 md:mt-12">
        <h1 className="font-anton uppercase leading-[0.82] tracking-tighter text-white text-[20vw] sm:text-[18vw] md:text-[14vw] lg:text-[12.5rem]">
          <span className="block">BIG STICK</span>
          <span className="block text-[#e11d2a] -mt-2 md:-mt-4">
            ENERGY<span className="text-white">.</span>
          </span>
        </h1>
      </div>

      {/* Sub copy + CTA row */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 mt-10 md:mt-16 grid grid-cols-1 md:grid-cols-12 gap-8 items-end pb-20 md:pb-32">
        <div className="md:col-span-5">
          <p className="text-neutral-300 text-base md:text-lg leading-relaxed max-w-md">
            Custom team jerseys & tees for the kids who play loud, hit clean,
            and never check the scoreboard until it's over.
          </p>
        </div>

        <div className="md:col-span-4 md:col-start-7 flex flex-col sm:flex-row gap-3">
          <button
            onClick={onCta}
            data-testid="hero-cta-button"
            className="group inline-flex items-center justify-between gap-3 bg-[#e11d2a] hover:bg-[#ff3340] text-white font-bold uppercase tracking-wide text-sm px-6 py-4 transition-all"
          >
            Gear Up
            <ArrowUpRight
              size={18}
              className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
            />
          </button>
          <a
            href="#gear"
            data-testid="hero-secondary-btn"
            className="inline-flex items-center justify-center gap-2 border border-neutral-700 hover:border-white text-white font-bold uppercase tracking-wide text-sm px-6 py-4 transition-colors"
          >
            See the Gear
          </a>
        </div>

        <div className="md:col-span-3 md:col-start-10 flex md:justify-end">
          <div className="flex items-center gap-3 text-[10px] tracking-[0.25em] uppercase text-neutral-400">
            <span className="font-anton text-3xl text-white">12</span>
            <div className="leading-tight">
              <div>Players</div>
              <div>One Squad</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll hint */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 text-[10px] tracking-[0.3em] uppercase text-neutral-500 flex flex-col items-center gap-2">
        <span>Scroll</span>
        <span className="w-px h-8 bg-gradient-to-b from-neutral-500 to-transparent" />
      </div>
    </section>
  );
}
